import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { TaskActionHandler } from '../contracts/task-action.contract';
import { Task, TaskType } from '../models/task.interface';
import * as TaskActions from '../store/task.actions';

@Injectable()
export class CheckPlannedAppointmentActionHandler implements TaskActionHandler<TaskType.CheckPlannedAppointment> {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  readonly type = TaskType.CheckPlannedAppointment;

  execute(task: Task<TaskType.CheckPlannedAppointment>): void {
    this.store.dispatch(TaskActions.startTask({ task }));
    this.router.navigate(['/tasks', task.id], { queryParams: { createdAt: task.createdAt.toISOString() } });
  }
}
